import { FC, useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const variants = {
  enter: (direction: number) => ({ x: direction > 0 ? 1000 : -1000, opacity: 0 }),
  center: { x: 0, opacity: 1 },
  exit: (direction: number) => ({ x: direction < 0 ? 1000 : -1000, opacity: 0 })
};

const transition = {
  x: { type: 'spring', stiffness: 300, damping: 30 },
  opacity: { duration: 0.2 }
};

export type AnimatedContentProps = {
  activeContentIndex: number;
};

const AnimatedContent: FC<AnimatedContentProps> = ({ children, activeContentIndex }) => {
  const prevIndex = useRef(activeContentIndex);
  const direction = prevIndex.current > activeContentIndex ? -1 : 1;

  useEffect(() => {
    prevIndex.current = activeContentIndex;
  }, [activeContentIndex]);

  return (
    <>
      <AnimatePresence initial={false} custom={direction}>
        <motion.div
          key={activeContentIndex}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={transition}
        >
          {children?.[activeContentIndex]}
        </motion.div>
      </AnimatePresence>
    </>
  );
};

export default AnimatedContent;
